import * as React from "react";

export function useClickOutside<T>(element: React.RefObject<T>, onClickOutside: () => void): void {
  React.useEffect(() => {
    const onClick = (event: Event): void => {
      // TODO: type of current
      if (element.current && !(element.current as unknown as HTMLDivElement).contains(event.target as Node | null)) {
        onClickOutside();
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => {
      document.removeEventListener("mousedown", onClick);
    };
  }, [element]);
}
